function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Online inquiries are another important element in the sales funnel.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox attaches to the web forms on your website, tracks and reports automatically online inquiries to Google and Facebook, so you could see the conversions in their analytics tools. To make things complete, WhiteBox is able to track the consequent email communication between the user and your business and is able to report to all stakeholders as well. Get information about:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("What is the subject the online inquiries?")]),_vm._v(" "),_c('li',[_vm._v("Does my back office answer to these inquiries?")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/forms","interaction":"forms","title":"(Web Forms)|monitoring","image":"/img/interactions/9.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }